import { Theme } from '@ui'

const theme: Theme = {
  colors: {
    primary: '#1B6CA8',
    green: '#6D9433',
    green2: '#1B7A44',
    orange: '#C9700F',
    black: '#343434',
    yellow: '#ECD072',
    lightBlue: '#C9E1F4',
    lightBlue2: '#82BCEA',
    red: '#C73A15',
    gray1: '#667079',
    gray2: '#6B6E71',
    gray3: '#646D74',
    gray4: '#D6D6D6',
    gray5: '#F5F5F5',
    white: '#FFFFFF',
    schedule: {
      min: '#0086D0',
      nom: '#D96702',
      auto: '#11943F',
      boost: '#d63031',
    },
    new: '#1B7A44',
    warning: '#7F6308',
    error: '#E64C28',
  },
  sizes: {
    /* eslint-disable id-length */
    xs: 0.8,
    s: 0.9,
    m: 1.1,
    l: 1.3,
    xl: 1.5,
    /* eslint-enable id-length */
  },
}

export default theme
